(function() {
  // Check if Page has a mailing address section before sending request
  const checkIfValidPage = document.getElementById("ipstack_request");
  if (!checkIfValidPage) return;

  if (checkIfValidPage) {
    // Get IP
    const getIp = new XMLHttpRequest();
    getIp.addEventListener("load", function() {
      try {
        const response = JSON.parse(getIp.response);
        if (!response || !response.ip) return;

        const ip = response.ip;

        // After IP has been fetched
        // Then call for location
        const accessKey = "67ca1e1ad4f856a694c56d2109b303a6";
        const getLocation = new XMLHttpRequest();
        getLocation.addEventListener("load", function(e) {
          try {
            const response = JSON.parse(getLocation.response);

            if (response.error || !response.city) return;

            const country = document.getElementById("location_country") ? document.getElementById("location_country") : document.getElementById("signup_mailing_country");
            const city = document.getElementById("location_city") ? document.getElementById("location_city") :  document.getElementById("signup_mailing_city");
            const state = document.getElementById("location_state") ? document.getElementById("location_state") :  document.getElementById("signup_mailing_state");
            const zip = document.getElementById("location_zip") ? document.getElementById("location_zip") :  document.getElementById("signup_mailing_zip");
            const isEU = document.getElementById("data[is_eu]");


            city.setAttribute("value", response.city);
            zip.setAttribute("value", response.zip);

            // Set and manually call onchange event
            country.value = response.country_code;
            country.dispatchEvent(new Event('change'));


            if (state) {
              $(state).val(response.region_code).change();
            }
            if ( isEU ) {
              isEU.value =
                  (response.location && response.location.is_eu ? "Yes" : "No") ||
                  "Unknown";
            }

          } catch (err) {
            console.log(err)
          }
        });

        getLocation.open(
            "GET",
            "https://api.ipstack.com/" + ip + "?access_key=" + accessKey
        );
        getLocation.send();
      } catch (err) {}
    });
    getIp.open("GET", "https://api.ipify.org/?format=json");
    getIp.send();
  }
})();
